import { Data2 } from "../../../features/data-types"
import { Column, TextOrNumber } from "../../../features/ui"
import { isDefined } from "../../../utils/typeUtils"

interface Props {
    columns: Column[]
    rows: Data2[]
}

export const CsvContentSample = (props: Props) => {
    const { columns, rows } = props

    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th key={index} scope="col">{column.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map((column, columnIndex) => {
                            const value = row[column.name] as TextOrNumber
                            return <td key={columnIndex}>{isDefined(value) ? value.toString() : ''}</td>
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
